{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversaciones seleccionadas",
    "AGENT_SELECT_LABEL": "Seleccionar agente",
    "ASSIGN_CONFIRMATION_LABEL": "¿Está seguro que desea asignar {conversationCount} {conversationLabel} a",
    "UNASSIGN_CONFIRMATION_LABEL": "¿Está seguro de desasignar {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Volver",
    "ASSIGN_LABEL": "Asignar",
    "YES": "Si",
    "SEARCH_INPUT_PLACEHOLDER": "Buscar",
    "ASSIGN_AGENT_TOOLTIP": "Asignar un agente",
    "ASSIGN_TEAM_TOOLTIP": "Asignar equipo",
    "ASSIGN_SUCCESFUL": "Conversaciones asignadas con éxito.",
    "ASSIGN_FAILED": "Error al asignar conversaciones, inténtelo de nuevo.",
    "RESOLVE_SUCCESFUL": "Conversaciones resueltas con éxito.",
    "RESOLVE_FAILED": "Error al resolver las conversaciones, inténtelo de nuevo.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Las conversaciones visibles en esta página sólo están seleccionadas.",
    "AGENT_LIST_LOADING": "Cargando agentes",
    "UPDATE": {
      "CHANGE_STATUS": "Cambiar estado",
      "SNOOZE_UNTIL": "Posponer",
      "UPDATE_SUCCESFUL": "El estado de la conversación se actualizó con éxito.",
      "UPDATE_FAILED": "No se han podido actualizar las conversaciones. Inténtalo de nuevo."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Asignar etiqueta",
      "NO_LABELS_FOUND": "No se encontraron etiquetas para",
      "ASSIGN_SELECTED_LABELS": "Asignar etiquetas seleccionadas",
      "ASSIGN_SUCCESFUL": "Etiquetas asignadas correctamente.",
      "ASSIGN_FAILED": "Error al asignar etiquetas, inténtalo de nuevo."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Seleccionar equipo",
      "NONE": "Ninguna",
      "NO_TEAMS_AVAILABLE": "Todavía no hay equipos añadidos a esta cuenta.",
      "ASSIGN_SELECTED_TEAMS": "Asignar equipo seleccionado.",
      "ASSIGN_SUCCESFUL": "Equipos asignados correctamente.",
      "ASSIGN_FAILED": "Error al asignar equipo, inténtelo de nuevo."
    },
    "MERGE": {
      "TOOLTIP": "Fusionar conversaciones",
      "TITLE": "Fusionar conversaciones",
      "DESCRIPTION": "Selecciona una conversación de destino. Todas las demás conversaciones seleccionadas se fusionarán en ella — sus mensajes se moverán al destino y las conversaciones de origen se eliminarán.",
      "TARGET_LABEL": "Conversación de destino (se conservará)",
      "SOURCES_LABEL": "Conversaciones de origen (se eliminarán)",
      "SELECT_TARGET": "Selecciona una conversación como destino de la fusión",
      "WARNING": "Advertencia: Esta acción no se puede deshacer. Los mensajes de todas las conversaciones de origen se moverán a la conversación de destino y las conversaciones de origen se eliminarán permanentemente.",
      "SUBMIT": "Fusionar conversaciones",
      "CANCEL": "Cancelar",
      "SUCCESS_MESSAGE": "Conversaciones fusionadas correctamente",
      "ERROR_MESSAGE": "No se pudieron fusionar las conversaciones. Por favor, inténtalo de nuevo.",
      "CONFIRM": {
        "TITLE": "Confirmar fusión",
        "DESCRIPTION": "¿Estás seguro de que deseas fusionar {sourceCount} conversaciones en #{targetId}? Esta acción no se puede deshacer.",
        "YES": "Sí, fusionar",
        "CANCEL": "Cancelar"
      }
    }
  }
}
